const insuranceFc = [{
  desc: '理赔录入',
  options: {
    url: '/insurancefc/addInsuranceClaims',
    method: 'post'
  }
}, {
  desc: '保单录入(改版)',
  options: {
    url: '/insurancefc/addFcInsurance',
    method: 'post'
  }
}, {
  desc: '根据保单号查询详情(改版)',
  options: {
    url: '/insurancefc/queryInsuranceInfoByNoNewWay',
    argsParams: true
  }
}, {
  desc: '改版保单id查询(改版)',
  options: {
    url: '/insurancefc/queryInsuranceInfoNewWay',
    argsParams: true
  }
}, {
  desc: '更新保单(改版)',
  options: {
    url: '/insurancefc/updateInsuranceInfoCorrect',
    method: 'put'
  }
}, {
  desc: '非车被保人导入接口',
  options: {
    url: '/insurancefc/importInsuredFile',
    method: 'post'
  }
}, {
  desc: '非车理赔导入接口',
  options: {
    url: '/insurancefc/importClaimsFile',
    method: 'post'
  }
}, {
  desc: '非车保单被保人列表',
  options: {
    url: '/insurancefc/queryPageInsuredList',
    method: 'post'
  }
}, {
  desc: '保单号查询被保人信息',
  options: {
    url: '/insurancefc/queryInsuredInfoByNo',
    argsParams: true
  }
}, {
  desc: '新增/修改/删除非车保单单个被保人',
  options: {
    url: '/insurancefc/addOrUpdateInsured',
    method: 'post'
  }
}, {
  desc: '导出自定义产品列表',
  options: {
    url: '/insurancefc/exportProductList',
    method: 'post',
    responseType: 'arraybuffer'
  }
}]
export default insuranceFc



// WEBPACK FOOTER //
// ./src/api/insurancefc.js